export default "__VITE_ASSET__LA$dyJ7R__"